module.exports = __webpack_public_path__ + "static/media/produtos.3f99a4b5.png";